<fieldset [disabled]="!editable">
	<mat-table
		#dataTable
		*ngIf="data.locationDescriptions"
		[dataSource]="data.locationDescriptions"
		cdkDropList
		(cdkDropListDropped)="dropTable($event)"
	>
		<ng-container matColumnDef="name">
			<mat-header-cell *matHeaderCellDef> Nazwa </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.descriptionHeader.name }} </mat-cell>
		</ng-container>

		<ng-container matColumnDef="description">
			<mat-header-cell *matHeaderCellDef> Opis </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.convertedDescription }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="edit">
			<mat-header-cell *matHeaderCellDef></mat-header-cell>
			<mat-cell *matCellDef="let element; let i = index">
				<button
					mat-raised-button
					class="me-3"
					color="primary"
					[disabled]="!editable"
					(click)="editForm(element)"
				>
					<i class="fas fa-edit"></i> Edytuj
				</button>
				<button mat-raised-button color="warn" [disabled]="!editable" (click)="deleteDescription(i)">
					<i class="fa-solid fa-trash-can"></i> Usuń opis
				</button>
			</mat-cell>
		</ng-container>
		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag></mat-row>
	</mat-table>
	<div *ngIf="!data.locationDescriptions?.length" class="alert mt-4 alert-warning text-center">Brak opisów</div>
	<div class="d-flex w-100 justify-content-end">
		<button class="mt-3" color="primary" [disabled]="!editable" mat-raised-button (click)="dialogForm()">
			Dodaj opis
		</button>
	</div>
</fieldset>
